import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  BusinessCalendarCatalog,
  BusinessCalendarDraft,
  CalendarCalculationRequest,
  CalendarCalculationResult,
  CreateBusinessCalendarDraft,
  UpdateBusinessCalendarDraft,
} from './platform-business-calendars.models';

const options = {
  withCredentials: true,
  headers: new HttpHeaders({
    'skip-error-interceptor': 'yes',
    'skip-loading-interceptor': 'yes',
  }),
};

@Injectable({ providedIn: 'root' })
export class PlatformBusinessCalendarsService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);

  getCatalog() {
    return this.http.get<BusinessCalendarCatalog>(
      this.apis.core.manual.getPlatformBusinessCalendars(),
      options,
    );
  }
  calculate(request: CalendarCalculationRequest) {
    return this.http.post<CalendarCalculationResult>(
      this.apis.core.manual.postPlatformBusinessCalendarCalculation(),
      request,
      options,
    );
  }
  getDrafts() {
    return this.http.get<BusinessCalendarDraft[]>(
      this.apis.core.manual.getPlatformBusinessCalendarDrafts(),
      options,
    );
  }
  createDraft(request: CreateBusinessCalendarDraft, idempotencyKey: string) {
    return this.http.post<BusinessCalendarDraft>(
      this.apis.core.manual.getPlatformBusinessCalendarDrafts(),
      request,
      {
        ...options,
        headers: options.headers.set('Idempotency-Key', idempotencyKey),
      },
    );
  }
  saveDraft(
    id: number,
    eTag: string,
    request: UpdateBusinessCalendarDraft,
    idempotencyKey: string,
  ) {
    return this.http.put<BusinessCalendarDraft>(
      this.apis.core.manual.getPlatformBusinessCalendarDraft(id),
      request,
      {
        ...options,
        headers: options.headers
          .set('If-Match', eTag)
          .set('Idempotency-Key', idempotencyKey),
      },
    );
  }
  publishDraft(
    id: number,
    eTag: string,
    expectedRevision: number,
    idempotencyKey: string,
  ) {
    return this.http.post<BusinessCalendarDraft>(
      this.apis.core.manual.postPlatformBusinessCalendarDraftPublication(id),
      { expectedRevision },
      {
        ...options,
        headers: options.headers
          .set('If-Match', eTag)
          .set('Idempotency-Key', idempotencyKey),
      },
    );
  }
}
